<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <p>Please rate your problems with your memory over the last 24 hours (0 no problems; 10 worst imaginable)</p>
        <Radios
          name="memory-problems"
          :entry="existingEntry"
          @store-number="storeMemoryProblemLevel"
          data="memoryProblemLevel"
          amount="11"
        />
      </div>

      <div class="field">
        <p>Please rate problems with your concentration over the last 24 hours (0 no problems; 10 worst imaginable)</p>
        <Radios
          name="concentration-problems"
          :entry="existingEntry"
          @store-number="storeConcentrationProblemLevel"
          data="concentrationProblemLevel"
          amount="11"
        />
      </div>

      <div class="field">
          <p>Please rate problems with your clarity of thought over the last 24 hours (0 no problems; 10 worst imaginable)</p>
         <Radios
          name="clarity-thought"
          :entry="existingEntry"
          @store-number="storeClarityOfThought"
          data="clarityOfThought"
          amount="11"
        />
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your cognitive function</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >Cancel</button>
      </div>
    </form>
  </div>
</template>

<script>
import Radios from "@/components/Radios.vue";

export default {
  name: "Form",
  props: ["existingEntry", "day"],
  components: { Radios },
  methods: {
    storeMemoryProblemLevel(level) {
      this.form.memoryProblemLevel = level;
    },
    storeConcentrationProblemLevel(level) {
      this.form.concentrationProblemLevel = level;
    },
    storeClarityOfThought(level) {
      this.form.clarityOfThought = level;
    }
  },
  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        memoryProblemLevel: this.existingEntry
          ? this.existingEntry.data.memoryProblemLevel
          : 0,

        concentrationProblemLevel: this.existingEntry
          ? this.existingEntry.data.concentrationProblemLevel
          : 0,

        clarityOfThought: this.existingEntry
          ? this.existingEntry.data.clarityOfThought
          : 0
      }
    };
  }
};
</script>

<style>
button {
  margin-right: 1rem;
}
</style>
